import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  UpdateChangeView,
  UpdateChangeViewButtonIcon,
  UpdateIsTitleDashboard,
  UpdateShowTable,
  UpdateTitleDashboard,
} from './dashboard.actions';
import { DashboardState, IDashboadModel } from './dashboard.state';

@Injectable({ providedIn: 'root' })
export class DashboardFacade {
  @Select(DashboardState.getIsChangeView) isChangeView$: Observable<boolean>;
  @Select(DashboardState.getIsShowTable) dashboardModel$: Observable<IDashboadModel>;
  @Select(DashboardState.getButtonIcon) buttonIcon$: Observable<string>;
  @Select(DashboardState.getTitleDashboard) titleDashboard$: Observable<string>;
  @Select(DashboardState.getIsTitleDashboard) isTitleDashboard$: Observable<string>;
  constructor(private store: Store) {}
  public getIsTitleDashboard(value: boolean): void {
    this.store.dispatch(new UpdateIsTitleDashboard(value));
  }
  public getIsChangeView(value: boolean): void {
    this.store.dispatch(new UpdateChangeView(value));
  }
  public getIsShowTable(value: any, switcher: boolean): void {
    this.store.dispatch(new UpdateShowTable(value, switcher));
    // TODO Cambiar el state del boolean
  }
  public changeButtonIcon(): string {
    let iconToSend: string;
    this.buttonIcon$.subscribe((icon) => {
      if (icon === 'panel-view-icon') {
        iconToSend = 'list-view-icon';
      } else iconToSend = 'panel-view-icon';
    });
    this.store.dispatch(new UpdateChangeViewButtonIcon(iconToSend));
    return iconToSend;
  }
  public changeTitleDashboard(value: string): void {
    this.store.dispatch(new UpdateTitleDashboard(value));
  }
}
